import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { InputSharedModule } from './../../molecules/input/input.module';
import { IconSharedModule } from './../../atoms/icon/icon.module';
import { AlertSharedModule } from './../../molecules/alerts/alerts.module';
import { AddressLookUpServiceConfig } from './input.address.lookup.service';
import { InputAddressLookupSharedComponent } from './input.address.lookup.component';

@NgModule({
    declarations: [
        InputAddressLookupSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        HttpClientModule,
        AlertSharedModule,
        InputSharedModule,
        IconSharedModule
    ],
    exports: [
        InputAddressLookupSharedComponent
    ]
})

export class InputAddressLookupSharedModule {
    static forRoot(config: AddressLookUpServiceConfig): ModuleWithProviders {
        return {
            ngModule: InputAddressLookupSharedModule,
            providers: [
                {
                    provide: AddressLookUpServiceConfig,
                    useValue: config
                }
            ]
        };
    }
}
